import * as Fn from "../../../data/function";
export const setter = (modify, set) => ({
    modify,
    set,
});
export const of = () => setter((g) => (s) => g(s), (x) => (_) => x);
export const over = (g, s) => setter((h) => s.modify((x) => g(h(x))), s.set);
export const compose = (s1, s2) => setter(Fn.compose(s2.modify, s1.modify), (b) => s1.modify(s2.set(b)));

